import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useFormConfig } from '../../hooks/useFormConfig';
import { getHeaderLogoSrc } from '../../utils/tenant-logo-utils';
import ProgressBar from '../ProgressBar/ProgressBar';
import type { Props } from './types';

const GovHeader = styled.header`
    .govuk-width-container {
        border-bottom-color: transparent;
    }

    &.govuk-header {
        border-bottom: 0;
    }
    .govuk-header__container {
        display: block;
    }

    .govuk-header__product-name {
        margin-left: 0.5cm;
    }

    .govuk-header__logo-image {
        display: inline-block;
        width: auto;
        height: auto;
        max-width: 148px;
        max-height: 30px;
        vertical-align: middle;
    }
`;

function Header({ loading }: Props) {
  const { tenant } = useFormConfig();
  const logoSrc = getHeaderLogoSrc(tenant);

  return (
    <GovHeader className="govuk-header" role="banner">
      <div className="govuk-header__container govuk-width-container">
        <div className="govuk-header__logo">
          <Link
            to={tenant ? `/${tenant}` : '/'}
            className="govuk-header__link govuk-header__link--homepage"
          >
            <img src={logoSrc} alt="Logo" className="govuk-header__logo-image" />
            <span className="govuk-header__product-name">GovReturns</span>
          </Link>
        </div>
      </div>
      <ProgressBar loading={loading} />
    </GovHeader>
  );
}

export default Header;

